// extracted by mini-css-extract-plugin
export default {"logo":"navigationStyles_logo__6UgFn","navigationLogo":"navigationStyles_navigationLogo__9Nuqn","nav_container":"navigationStyles_nav_container__-HQrd"};